export default __webpack_public_path__ + "static/media/fb.8e3646a4.svg";